import Component from './src';

Component.install = function install(_Vue) {
  _Vue.component(Component.name, Component);
};

export default Component;
